var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SuggestLinkCard,{attrs:{"link-id":_vm.linkId,"href":_setup.href,"img-src":"/static/img/formats/sample/atena_lban.png","title":"封筒に貼るだけ。宛名を手書きしなくていい","lead":_vm.lead,"cta":"宛名ラベルを作る"}})
}
var staticRenderFns = []

export { render, staticRenderFns }